import { gql } from 'apollo-angular';

const ROLE_FIELDS = `
  roleId
  name
  description
  isSystem
  permissions
  adminCount
  dateCreated
  dateUpdated
`;

export const ADMIN_PERMISSION_CATALOGUE = gql`
  query adminPermissionCatalogue {
    adminPermissionCatalogue {
      key
      label
      section
      description
      view
      manage
    }
  }
`;

export const ADMIN_ACCESS_ROLES = gql`
  query adminAccessRoles {
    adminAccessRoles { ${ROLE_FIELDS} }
  }
`;

export const ADMIN_ACCESS_AUDIT_TRAILS = gql`
  query adminAccessAuditTrails($page: Int, $limit: Int) {
    adminAccessAuditTrails(page: $page, limit: $limit) {
      items {
        auditTrailId
        actorAdminId
        actorName
        action
        targetType
        targetRef
        details
        dateCreated
      }
      total
      page
      limit
    }
  }
`;

export const SAVE_ADMIN_ACCESS_ROLE = gql`
  mutation saveAdminAccessRole($input: SaveAdminAccessRoleInput!) {
    saveAdminAccessRole(input: $input) { ${ROLE_FIELDS} }
  }
`;

export const DELETE_ADMIN_ACCESS_ROLE = gql`
  mutation deleteAdminAccessRole($roleId: HashedId!) {
    deleteAdminAccessRole(roleId: $roleId) {
      message
    }
  }
`;

export const SET_ADMIN_ACCESS_ROLES = gql`
  mutation setAdminAccessRoles($adminId: AdminHashedId!, $roleIds: [HashedId!]!) {
    setAdminAccessRoles(adminId: $adminId, roleIds: $roleIds) { ${ROLE_FIELDS} }
  }
`;
